import React from 'react';
import { Col, isZeroOrDefined, Row } from '../../lib/utils';
import { CoachReportWriteRateList } from '../../services/useFeedDashboardQueryService';
import FeedCenterStatisticsFeedWritingPercentIcon from './Icon/FeedCenterStatisticsFeedWritingPercentIcon';
import SvgIcon from '../../components/SvgIcon';
import { colors } from '../../lib/colors';
import { DemiLightText, MediumText, RegularText } from '../../lib/Text';
import { createColumnHelper } from '@tanstack/react-table';
import Table from '../../components/Table/Table';

type Props = {
    coachReportWriteRateList: CoachReportWriteRateList[];
    onClickAllMemberWritingRate?: () => void; // 클릭 시 전체 회원 작성률 모달 열기
};
const limit = 3;
const columnHelper = createColumnHelper<CoachReportWriteRateList>();

// 테이블 컬럼 정의
const columns = [
    columnHelper.accessor('memberName', {
        id: 'memberName',
        header: () => (
            <DemiLightText fontSize={13} lineHeight={18} color={'#AEB2B7'} letterSpacing={-0.5}>
                회원명
            </DemiLightText>
        ),
        cell: (info) => (
            <RegularText fontSize={13} lineHeight={18} color={colors.Text_1}>
                {info.getValue()}
            </RegularText>
        ),
        size: 69,
        enableSorting: false,
    }),
    columnHelper.accessor('reportWriteRate', {
        id: 'reportWriteRate',
        header: () => (
            <DemiLightText fontSize={13} lineHeight={18} color={'#AEB2B7'} letterSpacing={-0.5}>
                작성률
            </DemiLightText>
        ),
        cell: (info) => (
            <RegularText fontSize={13} lineHeight={18} color={colors.Text_1}>
                {isZeroOrDefined(info.getValue()) ? info.getValue() : '-'}
            </RegularText>
        ),
        size: 69,
        enableSorting: false,
    }),
    columnHelper.accessor('reportCount', {
        id: 'reportCount',
        header: () => (
            <DemiLightText fontSize={13} lineHeight={18} color={'#AEB2B7'} letterSpacing={-0.5}>
                작성수/수업 수
            </DemiLightText>
        ),
        cell: (info) => (
            <RegularText fontSize={13} lineHeight={18} color={colors.Text_1}>{`${
                isZeroOrDefined(info.getValue()) ? info.getValue() : '-'
            }/${
                isZeroOrDefined(info.row.original.totalScheduleCount) ? info.row.original.totalScheduleCount : '-'
            }`}</RegularText>
        ),
        size: 92,
        enableSorting: false,
    }),
];

function FeedCoachStaticsPageRightRanking({ coachReportWriteRateList, onClickAllMemberWritingRate }: Props) {
    // 3개만 보여주기
    const limitCoachReportWriteRateList = coachReportWriteRateList?.slice(0, limit);
    return (
        <Col className="flex min-w-[282px] w-[282px] items-center justify-start ml-[24px]">
            {/* 일지 작성률 낮은 회원 */}
            <Col className="flex w-full min-h-[285px] bg-white rounded-[17px] py-[22px] px-[13px] border-[0.5px] border-solid border-[#E8E8E8] mb-[25px]">
                <Row className="flex items-center">
                    <Col className="flex items-center justify-center relative ">
                        <FeedCenterStatisticsFeedWritingPercentIcon width={26} height={26} iconSize={13} />
                        <SvgIcon
                            name="SvgWarningInCircle"
                            size={11}
                            fill={colors.red}
                            className=" absolute right-[8px] top-[-4px]"
                        />
                    </Col>
                    <RegularText fontSize={15} lineHeight={20} color={colors.Text_1}>
                        일지 작성률 낮은 회원 📉
                    </RegularText>
                </Row>
                {limitCoachReportWriteRateList && (
                    <Table
                        columns={columns}
                        data={limitCoachReportWriteRateList}
                        headerColor="white"
                        isIndex
                        isUnballancedRowColor
                        indexColumnWidth={30}
                        rowHeight={34}
                        className="mb-[30px]"
                        height={170}
                        rowRadius={6}
                        emptyComponent={
                            <Col className="flex w-full h-full justify-center items-center">
                                <RegularText fontSize={13} lineHeight={18} color={colors.Text_2}>
                                    데이터가 없습니다.
                                </RegularText>
                            </Col>
                        }
                    />
                )}
                <Row className="flex items-center justify-end cursor-pointer" onClick={onClickAllMemberWritingRate}>
                    <MediumText fontSize={13} lineHeight={18} color={colors.Text_1} className="mr-[8px]">
                        전체 보기
                    </MediumText>
                    <SvgIcon name="SvgRightStrokeArrow" size={12} fill={colors.trans} stroke={colors.Text_1} />
                </Row>
            </Col>
        </Col>
    );
}

export default FeedCoachStaticsPageRightRanking;
